import React from 'react';
import { Home, KeyRound, QrCode, Search } from 'lucide-react';
const CHAT_AVATAR = 'https://cdn.magicpatterns.com/uploads/bWheurp3vUHCL4f75s5nsV/image.png';
export type MobileTab = 'home' | 'search' | 'qr' | 'project' | 'chat' | 'family';
type NavigationVariant = 'guest' | 'authenticated';
type BottomNavProps = {
  active: MobileTab;
  onChange: (tab: MobileTab) => void;
  variant?: NavigationVariant;
};
export function BottomNav({
  active,
  onChange,
  variant = 'guest'
}: BottomNavProps) {
  const isGuest = variant === 'guest';
  return <nav aria-label={isGuest ? 'Guest app navigation' : 'Signed-in app navigation'} className={`flex h-[48px] shrink-0 items-center justify-around border-t border-white/20 px-2 ${isGuest ? 'bg-[#8f738d]/90' : 'bg-[#627083]/90'}`} data-id="element-19" data-mp="1l2mlb4gbe6je">
      <NavItem active={active === 'home'} label="Home" onClick={() => onChange('home')} data-id="element-20" data-mp="xcig4snh9yqa">
        <Home className="h-5 w-5" data-id="element-21" data-mp="xao463u6pgyc" />
      </NavItem>
      <NavItem active={active === 'search'} label="Search" onClick={() => onChange('search')} data-id="element-22" data-mp="12ajytcgzrw18">
        <Search className="h-5 w-5" data-id="element-23" data-mp="2gi6vmagrb6w3" />
      </NavItem>
      {isGuest ? <NavItem active={false} label="Sign in or create an account" onClick={() => onChange('family')} data-id="element-24" data-mp="2bkf7lrj8g4x6">
          <KeyRound className="h-5 w-5" data-id="element-25" data-mp="26sx2qse39k6x" />
        </NavItem> : <>
          <NavItem active={active === 'qr'} label="QR Scan" onClick={() => onChange('qr')} data-id="element-26" data-mp="22rtsclet8gd3">
            <QrCode className="h-5 w-5" data-id="element-27" data-mp="1xsqtjipfb6dk" />
          </NavItem>
          <NavItem active={active === 'chat'} label="Chat with AI" onClick={() => onChange('chat')} data-id="element-28" data-mp="1xubnp77tsnaw">
            <img src={CHAT_AVATAR} alt="" className="h-7 w-7 rounded-sm object-cover" data-id="element-29" data-mp="1ss2wafalptaw" />
          </NavItem>
        </>}
    </nav>;
}
function NavItem({
  active,
  label,
  onClick,
  children
}: {
  active: boolean;
  label: string;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return <button onClick={onClick} aria-label={label} aria-current={active ? 'page' : undefined} className={`grid h-9 w-9 place-items-center rounded-full transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white ${active ? 'bg-white/15 text-[#ffe054]' : 'text-white/85'}`} data-id="element-30" data-mp="3i828645ltwu8">
      {children}
    </button>;
}